import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-assigned-lawyer-dialog',
    templateUrl: './assigned-lawyer-dialog.component.html',
    standalone: false
})
export class AssignedLawyerDialogComponent implements OnInit {

  @Input() userName;
  @Input() sla;
  @Input() assignText;
  @Input() title;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
